import { Navigate } from "react-router-dom";
import Home from "./Home";
import { useAuthUser } from "@/hooks/useAuthUser";
import { useEffect, useState } from "react";

const Index = () => {
  const { user: clerkUser, profile, loading, isSignedIn, isLoaded } = useAuthUser();
  const [authChecked, setAuthChecked] = useState(false);
  const [shouldRedirect, setShouldRedirect] = useState(false);
  
  useEffect(() => {
    // Only check authentication once Clerk has loaded and we haven't checked yet
    if (!loading && isLoaded && !authChecked) {
      const isAuthenticated = isSignedIn && clerkUser && profile;
      
      setAuthChecked(true);
      
      if (isAuthenticated) {
        setShouldRedirect(true);
      }
    }
  }, [loading, isSignedIn, isLoaded, clerkUser, profile, authChecked]);
  
  // Show loading while we're checking auth status
  if (loading || !isLoaded || !authChecked) {
    return (
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-sm text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }
  
  if (shouldRedirect) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return <Home />;
};

export default Index;
